module.exports = __webpack_public_path__ + "static/sgfleet-logo-e2c458d29099269470ec9d8342a3afba.png";